import React, { createContext, useState, useContext, useEffect } from "react";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [shownMessageCount, setShownMessageCount] = useState(0);
  const [shownNotificationCount, setShownNotificationCount] = useState(0);

  const resetMessageBadge = () => setShownMessageCount(0);
  const resetNotificationBadge = () => setShownNotificationCount(0);

  useEffect(() => {
    const token = encodeURIComponent(localStorage.getItem("accessToken"));
    if (!token) return;

    const eventSource = new EventSource(`http://localhost:5009/sse/events?token=${token}`);

    eventSource.onopen = () => console.log("SSE connected");
    eventSource.onerror = (err) => console.error("SSE error", err);

    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("SSE Event:", data);

        if (data.type === "MESSAGE") {
          setMessages(prev => [data, ...prev]);
          setShownMessageCount(prev => prev + 1);
        } else if (data.type === "NOTIFICATION") {
          setNotifications(prev => [data, ...prev]);
          setShownNotificationCount(prev => prev + 1);
        }
      } catch (e) {
        console.error("Invalid SSE data", e);
      }
    };

    return () => eventSource.close();
  }, []);

  return (
    <NotificationContext.Provider value={{
      messages, notifications,
      shownMessageCount, shownNotificationCount,
      resetMessageBadge, resetNotificationBadge
    }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => useContext(NotificationContext);